import { render, staticRenderFns } from "./usergroup.vue?vue&type=template&id=73e8e520&scoped=true"
import script from "./usergroup.vue?vue&type=script&lang=js"
export * from "./usergroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e8e520",
  null
  
)

export default component.exports